import { m, type MithrilVNode } from '../../mithril';
import { MaterialIcon, type MaterialSymbol } from './icons';

const ICON_FONT_CLASS = 'material-icons';
const SYMBOL_FONT_CLASS = 'material-symbols-outlined';

const CONST_CLASS_OBJ = { className: ICON_FONT_CLASS };
const CONST_SYMBOL_CLASS_OBJ = { className: SYMBOL_FONT_CLASS };

const MATERIAL_ICON_VALUES = new Set<string>(Object.values(MaterialIcon));

/**
 * Whether a plain string (e.g. an icon id stored on core-api, mirroring `FormFieldNestedListValues.icon`)
 * is a registered `MaterialIcon` ligature. Narrows at the one boundary where a stored string becomes a
 * renderable icon, rather than casting blindly — a removed/renamed icon id fails this check safely.
 */
export function isMaterialIcon(icon: string): icon is MaterialIcon {
	return MATERIAL_ICON_VALUES.has(icon);
}

interface IconOptions {
	className?: string;
	[key: string]: unknown;
}

function viewInFont(
	fontClass: string,
	constClassObj: { className: string },
	icon: MaterialIcon | MaterialSymbol | MithrilVNode,
	opts?: IconOptions
) {
	if (opts == null) {
		return m('i', constClassObj, icon);
	}

	if (opts.className) {
		opts.className = opts.className + ' ' + fontClass;
	} else {
		opts.className = fontClass;
	}

	return m('i', opts, icon);
}

export function view(icon: MaterialIcon | MithrilVNode, opts?: IconOptions) {
	return viewInFont(ICON_FONT_CLASS, CONST_CLASS_OBJ, icon, opts);
}

export function symbol(icon: MaterialSymbol | MithrilVNode, opts?: IconOptions) {
	return viewInFont(SYMBOL_FONT_CLASS, CONST_SYMBOL_CLASS_OBJ, icon, opts);
}

export const Icon = { view, symbol };
